import { DataGlueGraph, FunctionDefinition, NodeInstance } from '@glueapp/graph-types';
import { IntegrationAccess } from '@glueapp/graph-types';
import { Node } from '@glueapp/graph-types';

type IntegrationAccessProviderDictionary = { [key: string]: IntegrationAccess[] };

const updateNodeInstanceIntegrationAccess = (
    nodeInstance: NodeInstance,
    providerIntegrationAccessMap: IntegrationAccessProviderDictionary,
    nodeLibraryIDDictionary: { [key: string]: Node },
): NodeInstance => {
    const node = nodeLibraryIDDictionary[nodeInstance.nodeId];
    if (node.integration) {
        const applicableIntegrationAccesses: IntegrationAccess[] | undefined = providerIntegrationAccessMap[node.integration.provider];
        if (applicableIntegrationAccesses && nodeInstance.selectedIntegrationAccess) {
            const matchingIA = applicableIntegrationAccesses.find(ia => ia.id === nodeInstance.selectedIntegrationAccess?.id);
            if (matchingIA) {
                return nodeInstance;
            }
        }
        return {
            ...nodeInstance,
            selectedIntegrationAccess: applicableIntegrationAccesses?.[0],
        };
    }
    return nodeInstance;
};

const updateFunctionIntegrationAccess = (
    functionDef: FunctionDefinition,
    providerIntegrationAccessMap: IntegrationAccessProviderDictionary,
    nodeLibraryIDDictionary: { [key: string]: Node },
): FunctionDefinition => {
    return {
        ...functionDef,
        nodeInstances: functionDef.nodeInstances.map(nodeInstance =>
            updateNodeInstanceIntegrationAccess(nodeInstance, providerIntegrationAccessMap, nodeLibraryIDDictionary),
        ),
    };
};

export function updateGraphIntegrationAccess(
    graph: DataGlueGraph,
    integrationAccesses: IntegrationAccess[],
    nodeLibraryIDDictionary: { [key: string]: Node },
): DataGlueGraph {
    const providerIntegrationAccessMap: IntegrationAccessProviderDictionary =
        integrationAccesses.reduce<IntegrationAccessProviderDictionary>((acc, ia) => {
            if (acc.hasOwnProperty(ia.provider)) {
                acc[ia.provider].push(ia);
            } else {
                acc[ia.provider] = [ia];
            }
            return acc;
        }, {});

    return {
        ...graph,
        nodeInstances: graph.nodeInstances.map(nodeInstance =>
            updateNodeInstanceIntegrationAccess(nodeInstance, providerIntegrationAccessMap, nodeLibraryIDDictionary),
        ),
        functions: graph.functions.map(functionDef =>
            updateFunctionIntegrationAccess(functionDef, providerIntegrationAccessMap, nodeLibraryIDDictionary),
        ),
    };
}
